import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchClientSpocListResponse>}
 */
export function requestbusinesscenter(params) {
  // return fetch.get(`${BASE_URL}/api/app/business-center/`, {
  //   params: {limit: Number.MAX_SAFE_INTEGER}
  // });
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/business-center`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/business-center?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestCreateBusinessCenter(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.post(
    `${BASE_URL}/api/app/business-center/${data.location_id}/add/`,
    data
  );
}

export function requestFloorBookingDetails(params) {
  // console.log(params);
  if (params !== undefined) {
    const data = { ...params }; //${data.location_id}
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getFloorBookingDetails/${data.businesscenterId}?startDate=${data.startDate}&endDate=${data.endDate}&agreementId=${data.agreementId}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}
export function requestFloorSeatDetails(params) {
  // console.log(params);
  if (params !== undefined) {
    const data = { ...params }; //${data.location_id}
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getFloorSeatDetails/${data.businesscenterId}?startDate=${data.startDate}&endDate=${data.endDate}&agreementId=${data.agreementId}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}

export function requestFloorSuiteDetails(params) {
  if (params !== undefined) {
    const data = { ...params };
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getFloorSuiteDetails/${data.businesscenterId}?startDate=${data.startDate}&endDate=${data.endDate}&agreementId=${data.agreementId || ""}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}

/** Suites by location only (no date filter - for lead phase) */
export function requestSuitesByLocation(locationId) {
  if (locationId) {
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getSuitesByLocation/${locationId}`,
      { params: { limit: Number.MAX_SAFE_INTEGER } }
    );
  }
}

/** Suites by floor/businessCenter only (for lead phase - Building → Floor → Suite flow) */
export function requestSuitesByFloor(businesscenterId) {
  if (businesscenterId) {
    return fetch.get(
      `${BASE_URL}/api/app/business-center/getFloorSuiteDetails/${businesscenterId}`,
      { params: { limit: Number.MAX_SAFE_INTEGER } }
    );
  }
}

/**
 * All suites in a location with date-based Vacant/Occupied (one round-trip).
 * Body: { locationId, startDate?, endDate?, agreementId?, floorIds?: string[] }
 */
export function requestLocationSuiteAvailability(body) {
  return fetch.post(
    `${BASE_URL}/api/app/business-center/getLocationSuiteAvailability`,
    body
  );
}

export function requestAllFloorBookingDetails(params) {
  // console.log(params);
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/business-center/getAllBusinessCentre`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/business-center/getAllBusinessCentre?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestUpdateWorkstationStatus(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.post(
    `${BASE_URL}/api/app/business-center/change-inventory-status/${value._id}`,
    data
  );
}

export function requestUpdateBusinessCenterStatus(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.post(
    `${BASE_URL}/api/app/business-center/changeState/${value._id}`,
    data
  );
}
